<template>
  <div>
      <div class="breadcrumb-wrap">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb-custom"
      >
        <el-breadcrumb-item>公告管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="gg-w">
      <el-input type="textarea" :rows="8" v-model="content" />
    </div>
    <div class="submit-wrap">
      <el-button @click="udpate">
        更新
      </el-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "Role",
  data() {
    return {
      content: "",
    };
  },
  components: {},
  mounted() {
    this.getGg();
  },
  methods: {
    async udpate() {
      let r = await axios.post("/admin/gg/update", {
        content: this.content,
      });
      if (r.code == 0) {
        this.$message.success("更新成功");
      }
    },
    async getGg() {
      this.loading = true;
      let r = await axios.get("/admin/gg/list", {
        params: { page: this.page, size: this.size },
      });
      if (r.code == 51) {
        this.loading = false;
        this.emptyText = "无权限";
        return;
      }
      this.content = r.data.content;
    },
  },
};
</script>
<style scoped>
.gg-w {
  padding: 30px;
}
.submit-wrap {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/main/admin/Gg.vue